import styleInject from './../../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".PaymentLogo-module_paymentIcon__L1q16 {\n  color: var(--pp-color-icon-primary);\n}";
var styles = {"paymentIcon":"PaymentLogo-module_paymentIcon__L1q16"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=PaymentLogo.module.scss.js.map
